'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ConfirmDialogState = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class;

var _ConfirmDialogState = require('./ConfirmDialogState');

Object.defineProperty(exports, 'ConfirmDialogState', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ConfirmDialogState).default;
  }
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _Modal = require('../Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _Dialog = require('../Dialog');

var _ConfirmDialogState2 = _interopRequireDefault(_ConfirmDialogState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfirmDialog = (0, _mobxReact.observer)(_class = function (_React$Component) {
  (0, _inherits3.default)(ConfirmDialog, _React$Component);

  function ConfirmDialog() {
    (0, _classCallCheck3.default)(this, ConfirmDialog);
    return (0, _possibleConstructorReturn3.default)(this, (ConfirmDialog.__proto__ || (0, _getPrototypeOf2.default)(ConfirmDialog)).apply(this, arguments));
  }

  (0, _createClass3.default)(ConfirmDialog, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          state = _props.state,
          title = _props.title,
          yes = _props.yes,
          no = _props.no,
          danger = _props.danger,
          disabled = _props.disabled,
          children = _props.children;

      var yesButtonProps = (0, _defineProperty3.default)({}, danger ? 'danger' : 'primary', true);
      return _react2.default.createElement(
        _Modal2.default,
        { isOpened: state.isOpened, onRequestClose: state.no },
        _react2.default.createElement(
          _Dialog.Dialog,
          null,
          title && _react2.default.createElement(
            _Dialog.DialogTitle,
            null,
            title
          ),
          _react2.default.createElement(
            _Dialog.DialogContent,
            null,
            children
          ),
          _react2.default.createElement(
            _Dialog.DialogFooter,
            null,
            _react2.default.createElement(
              _Dialog.DialogButton,
              { onClick: state.no, disabled: disabled },
              no
            ),
            _react2.default.createElement(
              _Dialog.DialogButton,
              (0, _extends3.default)({}, yesButtonProps, { onClick: state.yes, disabled: disabled }),
              yes
            )
          )
        )
      );
    }
  }]);
  return ConfirmDialog;
}(_react2.default.Component)) || _class;

exports.default = ConfirmDialog;


ConfirmDialog.propTypes = {
  state: _propTypes2.default.instanceOf(_ConfirmDialogState2.default),
  title: _propTypes2.default.string,
  yes: _propTypes2.default.string,
  no: _propTypes2.default.string,
  danger: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  children: _propTypes2.default.node
};

ConfirmDialog.defaultProps = {
  yes: 'Ok',
  no: 'Cancel',
  title: 'Confirm',
  danger: false,
  disabled: false
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/ConfirmDialog/index.js
// module id = 251
// module chunks = 0